module.exports = __webpack_public_path__ + "img/send.0c19b4fa.svg";